import styled from 'styled-components';

import { Button } from 'src/components/core';
import { Typography } from 'src/typography';

export const StyledHeading = styled(Typography.Heading)`
  margin: 24px 0 8px;

  ${({ theme }) => theme.breakpoints.up('sm')} {
    margin-top: 48px;
  }
`;

export const StyledTitle = styled(Typography.Title)`
  color: var(--dcm-color-text-primary, ${({ theme }) => theme.colors.primaryBlack});
  margin: 32px 0 16px;
`;

export const StyledList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;

export const StyledListItem = styled(Typography.Body)`
  align-items: center;
  display: flex;
  margin: 12px 0;
  width: 100%;

  svg {
    margin-right: 12px;
  }

  path {
    stroke: #464f53;
  }
`;

export const ButtonGroup = styled.div`
  margin-top: 32px;
`;

export const StyledSignUpButton = styled(Button)`
  background: ${({ theme }) => theme.colors.dutchiePayGreen};
  padding: 16px 40px;

  ${({ theme }) => theme.breakpoints.down('xs')} {
    width: 100%;
  }
`;
